// brandPrimary and #f7fafc keep the legacy tab colors exactly; THEME's nearest tokens are #0066ff and #f9f9f9.
import { brandPrimary } from '@Styles/colors';
import { StyleSheet } from 'aphrodite';
import { SPACE, THEME } from '../Theme/theme';

export const styleSheet = StyleSheet.create({
	primaryTabList: {
		boxSizing: 'border-box',
		display: 'flex',
		':is([data-orientation="horizontal"])': {
			minHeight: 40,
			borderBottom: `1px solid ${THEME.colors.border.light}`,
		},
		':is([data-orientation="vertical"])': {
			flexDirection: 'column',
			height: 'fit-content',
			borderRight: `1px solid ${THEME.colors.border.light}`,
		},
	},
	primaryTabTrigger: {
		boxSizing: 'border-box',
		display: 'flex',
		alignItems: 'center',
		gap: SPACE[8],
		padding: `${SPACE[12]}px ${SPACE[16]}px`,
		cursor: 'pointer',
		border: 'none',
		background: 'none',
		color: THEME.colors.text.light,
		fontSize: THEME.typography.fontSizes.sm,
		':hover': {
			backgroundColor: '#f7fafc',
		},
		':is([data-disabled])': {
			opacity: 0.5,
			cursor: 'not-allowed',
		},
		':is([data-disabled]):hover': {
			backgroundColor: THEME.colors.background.light,
		},
		':is([data-state="active"])': {
			color: brandPrimary,
		},
		':is([data-orientation="horizontal"][data-state="active"])': {
			boxShadow: `0 2px 0 ${brandPrimary}`, // covers bottom border without using negative margin
		},
		':is([data-orientation="vertical"])': {
			width: '100%',
			justifyContent: 'flex-start',
		},
		':is([data-orientation="vertical"][data-state="active"])': {
			borderRight: `1px solid ${brandPrimary}`,
		},
	},
});
